import React, {Fragment, useEffect, useRef, useState} from "react";
import {translate} from "../../Services/translation";
import {FacetedFilterCheckbox} from "./FacetedFilterCheckbox";

export const FacetedFilterDropdown = ({group, onFacetChange}) => {
    const ref = useRef();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);


    return (
        <Fragment>
            <li ref={ref}>
                <button
                    className="faceted-filter__dropdown-button"
                    onClick={() => setIsOpen(!isOpen)}><span>{translate('product.dropdownselected', [group.selectedOptions.length])}</span>
                    <span
                        className={"faceted-filter__dropdown-button-arrow " + (isOpen ? "faceted-filter__dropdown-button--open" : "")}></span>
                </button>
                {isOpen && <ul className="faceted-filter__dropdown-list">
                    {group.options &&
                        group.options.map((item, itemIndex) => (
                            <li
                                key={`${item.label}-${itemIndex}`}
                                className="faceted-filter__dropdown-list-item"
                                role="faceted-search-item"
                            >
                                <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange}/>
                            </li>
                        ))}
                </ul>}
            </li>
        </Fragment>
    );
};
